import { IMdCmSearchFields } from "../types/ScmTypes";
import { MdEnableStatusEnum } from "../types/ScmEnums";

//系统标识
export const CLIENT_APP_CODE = "vrm";

export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_FIRST_PAGE_NUM = 1;
export const DEFAULT_REQUEST_TIMEOUT = 30000;
enum ITableSize {
    LARGE = "large",
    SMALL = "small",
    MIDDLE = "middle"
}
export const tableSize = ITableSize.LARGE
//API请求环境
const baseRequestUrl = {
    "TESTAPI": "https://test-api.laoniuche.cn",
    "DEV": "https://api.peijian88.cn",
    "TEST": "https://zzw-api.laoniuche.cn",
    "PROD": "https://zzw-api.yunhaogroup.com",
    "STAGE": "https://api.beiben88.com",
    "SHOW": "https://show-api.laoniuche.cn"
}
const baseQrUrl = {
    "TEST": "http://hd-vrm.laoniuche.cn/",
    "PROD": "https://hdszgfzz.yunhaogroup.com/",
    "TESTAPI": "https://test-api.laoniuche.cn",
    "DEV": "https://api.peijian88.cn",
    "STAGE": "https://api.beiben88.com",
    "SHOW": "https://show-api.laoniuche.cn"
}
//财务的请求环境
const baseFmsRequestUrl = {
    "TESTAPI": "https://test-api.laoniuche.cn",
    "DEV": "https://api.peijian88.cn",
    "TEST": "https://zzw-api.laoniuche.cn",
    "PROD": "https://hd-api.yunhaogroup.com",
    "STAGE": "https://api.beiben88.com",
    "SHOW": "https://show-api.laoniuche.cn"


}
const baseChatGPTUrl = {
    "TESTAPI": "https://chat.laoniuche.cn/#/chat",
    "DEV": `https://chat.laoniuche.cn/#/chat`,
    "TEST": `https://chat.laoniuche.cn/#/chat`,
    "PROD": `https://chat.yunhaogroup.com/#/chat`,
    "STAGE": `https://chat.laoniuche.cn/#/chat`,
    "SHOW": "https://chat.laoniuche.cn/#/chat"
}
//鉴权的请求环境
const baseAuthRequestUrl = {
    "TESTAPI": "https://test-api.laoniuche.cn",
    "DEV": "https://api.peijian88.cn",
    "TEST": `https://zzw-api.laoniuche.cn`,
    "PROD": 'https://hd-api.yunhaogroup.com',
    "STAGE": "https://api.beiben88.com",
    "SHOW": "https://show-api.laoniuche.cn"
}

//鉴权2的请求环境
const baseAuth2RequestUrl = {
    "TESTAPI": "https://test-api.laoniuche.cn",
    "DEV": "https://api.peijian88.cn",
    "TEST": `https://zzw-api.laoniuche.cn`,
    "PROD": 'https://hd-api.yunhaogroup.com',
    "STAGE": "https://api.beiben88.com",
    "SHOW": "https://show-api.laoniuche.cn"
}


//根据环境变量自动获取图片查看地址
export const getBaseImgLookUrl = (md5: string) => {
    //自动选择环境
    return `${getBaseRequestUrl()}/zzw-fsrv/fetch/${md5}?Authorization=${getToken()}`
}

//根据环境变量自动获取图片上传地址
export const getBaseImgUploadUrl = () => {
    //自动选择环境
    return `${getBaseRequestUrl()}/zzw-fsrv/upload_file?Authorization=${getToken()}`
}

//根据环境变量自动获取图片上传地址
export const getBaseUploadData = () => {
    return {
        appCode: CLIENT_APP_CODE,
        fileMode: 0,
    }
}

const baseWSRequestUrl = {
    TESTAPI: `ws://localhost:8089/fms`,
    DEV: `ws://localhost:8089/fms`,
    TEST: `wss://192.168.110.121:8089/fms`,
    PROD: 'ws://fms.websocket.yunhaogroup.com/fms',
    STAGE: 'ws://82.156.190.89:8089/fms',
};
const baseCiRequestUrl = {
    TESTAPI: `https://test.api.yunhaochefu.com`,
    DEV: `https://test.api.yunhaochefu.com`,
    TEST: `https://test.api.yunhaochefu.com`,
    PROD: 'https://api.yunhaochefu.com',
    STAGE: 'https://test.api.yunhaochefu.com',
    SHOW: "https://show-api.laoniuche.cn"
};

//根据环境变量自动获取请求地址
export const getBaseRequestUrl = () => {
    //自动选择环境
    //....
    const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE" | "TESTAPI";
    return baseRequestUrl[REACT_APP_ENV ?? "DEV"]
};

//根据环境变量自动获取请求地址
export const getBaseFmsRequestUrl = () => {
    const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE" | "TESTAPI";
    return baseFmsRequestUrl[REACT_APP_ENV ?? "DEV"]
};
//根据环境变量自动获取请求地址
export const getBaseCiRequestUrl = () => {
    const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE" | "TESTAPI";
    return baseCiRequestUrl[REACT_APP_ENV ?? "DEV"]
};

export const getBaseWSRequestUrl = () => {
    //自动选择环境
    //....
    const REACT_APP_ENV = process.env.REACT_APP_ENV as 'DEV' | 'TEST' | 'PROD' | "STAGE" | "TESTAPI";
    return baseWSRequestUrl[REACT_APP_ENV ?? 'DEV'];
};

//获取生产地址(因发票识别需要使用https,所以发票图片上传使用生产地址)
export const getProdBaseRequestUrl = () => {
    return baseRequestUrl['PROD']
}
//根据环境变量自动获取鉴权请求地址
export const getBaseChatGPTUrl = () => {
    const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | 'STAGE' | "TESTAPI";
    return baseChatGPTUrl[REACT_APP_ENV ?? "DEV"]
};
export const getBaseAuthRequestUrl = () => {
    const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | 'STAGE' | "TESTAPI";
    return baseAuthRequestUrl[REACT_APP_ENV ?? "DEV"]
};

//根据环境变量自动获取鉴权请求地址
export const getBaseAuth2RequestUrl = () => {
    const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | 'STAGE' | "TESTAPI";
    return baseAuth2RequestUrl[REACT_APP_ENV ?? "DEV"]
};
export const getQrcodeUrl = () => {
    const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | 'STAGE' | "TESTAPI";
    return baseQrUrl[REACT_APP_ENV ?? "DEV"]
};
//服务器自定义错误码
export const INTERNAL_SERVER_ERROR_CODE = 500;
//token存储KEY值
export const TOKEN_KEY = "token";
//获取token
export const getToken = () => {
    return sessionStorage.getItem(TOKEN_KEY) ?? "default-token-str"
};
//存储token
export const setToken = (token: string) => {
    sessionStorage.setItem(TOKEN_KEY, token)
};
//主数据通用字段定义
export const defaultMdCmParam: IMdCmSearchFields = {
    sourceApp: "vrm",
    sourceAuthKey: "",
    branch: "main",
    ver: undefined,
    enable: MdEnableStatusEnum.ENABLE,
};
//财务通用字段定义
export const defaultMdCmParamAccout: IMdCmSearchFields = {
    sourceApp: "vrm",
    sourceAuthKey: "",
    branch: "vrm",
};
export const branchDs = [
    { label: "财务分支", value: "fms" },
    { label: "主分支", value: "main" },
    { label: "供应链分支", value: "scm" },
    { label: "维保分支", value: "vrm" },
]